/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { CurrentUsageContext } from '../contexts';

export const useCurrentUsageStore = () => useContext(CurrentUsageContext);
